export const TITLE_TABLE_SIZE = 29;